"use strict";

/** @format */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adjustToViewport = exports.calculatePosition = exports.PopoverUtils = void 0;
const data_1 = require("../../data");
// Constants from configuration
const POPOVER_OFFSET = data_1.popoverConfig.positioning.offset.default;
const VIEWPORT_OFFSET = data_1.popoverConfig.positioning.offset.viewport;
const HALF_DIVIDER = data_1.popoverConfig.positioning.divider.half;
const ALIGNMENT_MAPPING = data_1.popoverConfig.alignment.mapping;
const PADDING_CLASSES = data_1.popoverConfig.padding.classes;
const BACKGROUND_CLASSES = data_1.popoverConfig.background.classes;
class PopoverUtils {
  /**
   * Calculate positioning classes based on position and alignment
   */
  static getPositionClass(position, alignment) {
    const positionClass = `position-${position}`;
    const alignmentClass = `alignment-${ALIGNMENT_MAPPING[alignment || 'center']}`;
    return `${positionClass} ${alignmentClass}`;
  }
  /**
   * Get the appropriate padding class
   */
  static getPaddingClass(padding) {
    return PADDING_CLASSES[padding || 'default'] || PADDING_CLASSES['default'];
  }
  /**
   * Get background color class based on styleColor
   */
  static getBackgroundClass(styleColor) {
    return BACKGROUND_CLASSES[styleColor || 'light'] || BACKGROUND_CLASSES['light'];
  }
}
exports.PopoverUtils = PopoverUtils;
const calculatePosition = (anchorRect, popoverRect, position, alignment) => {
  let top = 0;
  let left = 0;
  switch (position) {
    case 'top':
      top = -(popoverRect.height + POPOVER_OFFSET);
      left = anchorRect.width / HALF_DIVIDER - popoverRect.width / HALF_DIVIDER;
      break;
    case 'bottom':
      top = anchorRect.height + POPOVER_OFFSET;
      left = anchorRect.width / HALF_DIVIDER - popoverRect.width / HALF_DIVIDER;
      break;
    case 'left':
      top = anchorRect.height / HALF_DIVIDER - popoverRect.height / HALF_DIVIDER;
      left = -(popoverRect.width + POPOVER_OFFSET);
      break;
    case 'right':
      top = anchorRect.height / HALF_DIVIDER - popoverRect.height / HALF_DIVIDER;
      left = anchorRect.width + POPOVER_OFFSET;
      break;
  }
  if (position === 'top' || position === 'bottom') {
    switch (alignment) {
      case 'first':
        left = 0;
        break;
      case 'last':
        left = anchorRect.width - popoverRect.width;
        break;
    }
  } else if (position === 'left' || position === 'right') {
    switch (alignment) {
      case 'first':
        top = 0;
        break;
      case 'last':
        top = anchorRect.height - popoverRect.height;
        break;
    }
  }
  return {
    top,
    left
  };
};
exports.calculatePosition = calculatePosition;
const adjustToViewport = (left, top, popoverRect, anchorRect) => {
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;
  let adjustedLeft = left;
  let adjustedTop = top;
  if (anchorRect.width + popoverRect.width + POPOVER_OFFSET > viewportWidth) adjustedLeft = viewportWidth - popoverRect.width - VIEWPORT_OFFSET;
  if (anchorRect.height + popoverRect.height + POPOVER_OFFSET > viewportHeight) adjustedTop = viewportHeight - popoverRect.height - VIEWPORT_OFFSET;
  return {
    adjustedTop,
    adjustedLeft
  };
};
exports.adjustToViewport = adjustToViewport;
